import React, { useContext, useEffect } from 'react';
import BottomDraw from '../bottomDraw/bottomDraw';
import { UserContext } from '../context/userContext';
import { LogOutBtnGrp, LogOutHeader, NoBtn, YesBtn } from './styles';
import { clearDb } from '../../db/db';
import { getSSOLogoutRedirectUrl } from '../../utils/auth';
import { EventIDs } from '../../analytics/events';
import { track } from '../../analytics/analytics';

interface Props {
  isOpen: any;
  closeLogOutDrawer: () => void;
}
const deleteAllCookies = () => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++)
    deleteCookie(cookies[i].split('=')[0]);
};
const setCookie = (name: string, value: string, expirydays: number) => {
  const d = new Date();
  d.setTime(d.getTime() + expirydays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=${value}; ${expires}`;
};
const deleteCookie = (name: string) => {
  setCookie(name, '', -1);
};

const LogoutDraw: React.FC<Props> = ({ isOpen, closeLogOutDrawer }) => {
  const { auth, email } = useContext<Record<string, any>>(UserContext);
  const payload = {
    email,
  };

  useEffect(() => {
    if (isOpen) {
      track(EventIDs.LOGOUT_DRAW, payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const clearStorage = async () => {
    try {
      localStorage.clear();
      deleteAllCookies();
      caches.delete('dynamic-resources');
      clearDb();
    } catch (e) {
      // console.log('Failed to cancel storage.');
    }
  };

  const logOutClick = () => {
    track(EventIDs.CONFIRM_LOGOUT, payload);
    auth.removeUser();
    clearStorage();
    closeLogOutDrawer();
    window.location.replace(getSSOLogoutRedirectUrl());
  };

  const cancelLogout = () => {
    track(EventIDs.CANCEL_LOGOUT, payload);
    closeLogOutDrawer();
  };

  const closeLogout = () => {
    track(EventIDs.CLOSE_LOGOUT_DRAW, payload);
    closeLogOutDrawer();
  };

  return (
    <BottomDraw
      isOpen={isOpen}
      drawHeight={258}
      logout={true}
      closeBottomDraw={closeLogout}
      title="Log Out"
      content={
        <>
          <LogOutHeader>Are you sure you want to logout?</LogOutHeader>
          <LogOutBtnGrp>
            <YesBtn onClick={logOutClick}>Yes</YesBtn>
            <NoBtn onClick={cancelLogout}>No</NoBtn>
          </LogOutBtnGrp>
        </>
      }
    />
  );
};

export default LogoutDraw;
